<button type="button" [ngClass]="state" (click)="clicked.emit()">
  {{ text }}
</button>
